import { render } from "./HistoryPopover.vue?vue&type=template&id=24addbee&scoped=true"
import script from "./HistoryPopover.vue?vue&type=script&lang=js"
export * from "./HistoryPopover.vue?vue&type=script&lang=js"

import "./HistoryPopover.vue?vue&type=style&index=0&id=24addbee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24addbee"]])

export default __exports__